<template>

<div :disabled="disable" :class="{ pasifCard: disable }"
  elevation="3">
   <div v-if="disable"  style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru ekranında görüntülenmeyecektir. </span></div>
        <p class="ma-0">
            <strong style="color: black;" v-html="label"> </strong> <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> 
         </p> 
    <v-text-field v-model="value" :rules="listRules" persistent-hint :hint="hint"  :placeholder="placeholder" :prefix="prefix" :suffix="suffix">
                <!-- <template v-slot:label>
                  <p> 
                    <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> <strong v-html="label"> </strong>  
                  </p>
        </template> -->
                      <template v-slot:append-outer>
    <slot name="edit"></slot>
   </template>
    </v-text-field>
</div>

  <!-- <v-card :disabled="disable" :class="{ pasifCard: disable }"
  elevation="3"
>
 <v-card-text >
    
</v-card-text>
</v-card> -->


</template>
<script>
import { mailSF } from '@/plugins/FieldDataFormat.js'
import { rules } from '@/plugins/custom.js'
export default {
  data() {
    return {
      value:"",
      label: "",
      required: false,
      counter: 20,
      color: null,
      disable: false,
      hint: "",
      prefix: "",
      suffix: "",
      rules: [],
      placeholder:"Yanıtınız"
    }
  },
  props: {
    ayar: {
      // default: '{"title":"","description":""}',
      default() {
        return mailSF;
      },
      type: Object
    },


  },
  methods: {
    dataBind(json) {
     // console.log("Vtext Json", json);
      // let ayarJson = JSON.parse(jsonStr);
      this.title = json.title;
      this.description = json.description;
      this.rules = json.rules;
      this.hint = json.hint;
      this.label = json.label;
      this.placeholder=json.placeholder;
      this.prefix=json.prefix;
      this.suffix=json.suffix;
          this.required=json.required;
          this.value=json.value;
          this.disable=json.disable;
    }
  },
  computed: {
     listRules() {
console.log("Mail listRules",this.rules.map(m=>rules[m]));
return this.rules.map(m=>rules[m]);
    
        },
    getAyar: function () {
      // `this` points to the vm instance
      return this.ayar;
    },  
    // iç kullanım için modelValue (opsiyonel)
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val); // v-model'e değer gönder
      }
    }
  
  },
  created() {
    this.dataBind(this.ayar);
  },
  watch: {
       ayar: {
            immediate: true,
            handler(newVal, oldVal) {
// console.log("handler:",newVal);
// if  (newVal.required){
// newVal.rules.push(value => !!value || 'Bu alana boş bırakılamaz.')
// }

              this.dataBind(newVal);
                //this.slots.forEach(slot => {
                //    if (slot.availability > 10) slot.availability = 10;
                //});
            },
            deep: true
        },
         value(n, old) {
      this.$emit('input', n);
    }

  },
  
}
</script>
<style scoped>
.pasifCard{
  background-color: gray !important;
}
</style>